import React, { useEffect, useState } from 'react';
import { Avatar, Box, IconButton, Paper, Typography } from '@mui/material';

import { useAuth } from '../hooks/useAuth';
import { AppLayout } from '../components/layout/AppLayout';
import { GridCard } from '../components/cards/GridCard';
import { useNavigate } from 'react-router-dom';
import { Edit } from '@mui/icons-material';
import { getUserPhotoUrl } from '../utils/getUserPhotoUrl';
import { useClinic } from '../hooks/useClinic';

interface NavItem {
  title: string;
  path: string;
  icon: string;
}

export const HomePage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
    const [userPhotoUrl, setUserPhotoUrl] = useState<string | null>(null);
    const { branches } = useClinic();
  
    useEffect(() => {
      const photoUrl = getUserPhotoUrl();
      setUserPhotoUrl(photoUrl);
    }, []);

      const handleEditProfile = () => {
    navigate('/profile');
  };
  const currentBranch = branches.find(b => b.id === user?.branchId);

  // 6 основных разделов в 2-колонной сетке
  const mainItems: NavItem[] = [
    { title: 'Акции', path: '/promotions', icon: '/images/promotions.png' },
    { title: 'О клинике', path: '/clinic', icon: '/images/clinic.png' },
    { title: 'Врачи', path: '/doctors', icon: '/images/doctors.png' },
    { title: 'Услуги', path: '/services', icon: '/images/services.png' },
    { title: 'Посоветовать', path: '/recommend-clinic', icon: '/images/recommendations.png' },
    { title: 'Записаться', path: '/book-appointment', icon: '/images/appointments.png'  },
  ];

  return (
    <AppLayout title="Главная">
      {/* Карточка пользователя */}
      <Box sx={{ mb: 1.5, display: 'flex', justifyContent: 'center', width: '100%' }}>
        <Paper
          sx={{
            width: '100%',
            maxWidth: { xs: '100%', sm: '359px', md: '480px', lg: '600px' },
            height: { xs: '90px', sm: '100px', md: '110px' },
            p: { xs: 1.5, sm: 2, md: 2.5 },
            borderRadius: '24px',
            backgroundColor: '#FFFFFF',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 }, width: '100%' }}>
            <Avatar
              src={userPhotoUrl || undefined}
              sx={{
                width: { xs: 48, sm: 56, md: 64 },
                height: { xs: 48, sm: 56, md: 64 },
                bgcolor: '#007AFF',
                fontSize: { xs: 18, sm: 22, md: 26 },
                fontWeight: 600,
                flexShrink: 0,
              }}
            >
              {user?.name?.charAt(0)?.toUpperCase() || '?'}
            </Avatar>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography sx={{ fontSize: { xs: '16px', sm: '18px', md: '20px' }, fontWeight: 700, color: '#000', minWidth: 0 }}>
                  {user?.name || 'Пользователь'}
                </Typography>
                <IconButton
                  size="small"
                  onClick={handleEditProfile}
                  sx={{
                    p: 0.4,
                    color: '#007AFF',
                    backgroundColor: 'rgba(0,122,255,0.1)',
                    borderRadius: '6px',
                    flexShrink: 0,
                    '&:hover': { backgroundColor: 'rgba(0,122,255,0.15)' },
                  }}
                >
                  <Edit sx={{ fontSize: { xs: 12, sm: 14, md: 16 } }} />
                </IconButton>
              </Box>
              <Typography sx={{ fontSize: { xs: '12px', sm: '13px', md: '14px' }, color: '#8E8E93', mt: 0.25 }}>
                {currentBranch?.name || 'Филиал не выбран'}
              </Typography>
            </Box>

            <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
              <Typography sx={{ fontSize: { xs: '14px', sm: '16px', md: '18px' }, fontWeight: 700, color: '#007AFF', whiteSpace: 'nowrap' }}>
                {user?.points?.toLocaleString() || 0} баллов
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>

      {/* Grid menu - фиксированная ширина колонок и gap */}
      <Box
        sx={{
          display: 'grid',
          // Фиксированная ширина колонок: ~177px карточка + gap
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)', // На mobile растягиваем на всю ширину
            sm: 'repeat(2, 1fr)', // На small tablet тоже растягиваем
            md: 'repeat(3, 177px)', // На md (900px+) фиксированные
            lg: 'repeat(4, 177px)', // На lg (1200px+) фиксированные
          },
          // aspectRatio для карточек вместо фиксированной высоты
          // Gap: фиксированный 12px на mobile/tablet, больше на desktop
          gap: {
            xs: '12px',
            sm: '12px',
            md: '16px',
            lg: '20px',
          },
          // Центрирование сетки в контейнере
          justifyContent: 'center',
          mx: 'auto',
          mb: 3,
          width: '100%',
        }}
      >
        {mainItems.map((item) => (
          <GridCard
            key={item.title}
            icon={item.icon}
            onClick={() => navigate(item.path)}
          />
        ))}
      </Box>
    </AppLayout>
  );
};
